import { TruncaFrac } from '../Auxiliares/TruncaFrac';

export function calculaICMS(
  valor: number,
  icms: number,
  reducao: number,
  tipoTrib: number,
  percentual: boolean,
  trunca: boolean,
): number {
  if ([0, 2, 8].includes(tipoTrib)) {
    const valCredICMS = (valor - valor * (reducao / 100)) * (icms / 100);
    const imposto = parseFloat((icms * (1 - reducao / 100)).toFixed(3));

    if (percentual) {
      if (trunca) return TruncaFrac(imposto, 3);
      return imposto;
    }
    if (trunca) return TruncaFrac(valCredICMS, 3);
    return parseFloat(valCredICMS.toFixed(3));
  }
  return 0;
}
